import Box from '@mui/material/Box';
import { Switch, TitlePart, dsV2 } from '@bloomays-lib/ui.shared';
import { useFeatureFlags, type FeatureFlags } from '../../contexts/FeatureFlagsProvider';

/**
 * Section « Fonctionnalités (bêta) » des Paramètres : interrupteurs de feature flags stockés en
 * localStorage (ce navigateur uniquement). Réservée au rôle System (gating dans Settings.tsx) —
 * opt-in interne de test, pas un contrôle d'accès.
 */
const FEATURES: { key: keyof FeatureFlags; title: string; description: string }[] = [
  {
    key: 'missionDashboardV2',
    title: 'Nouvelle fiche mission (V2)',
    description: 'Activé : nouvelle fiche mission V2. Désactivé (défaut) : version actuelle (V1).',
  },
  {
    key: 'jobsDashboardV2',
    title: 'Nouvelle gestion des jobs (V2)',
    description: 'Activé : nouvelle liste « Gestion des jobs » V2. Désactivé (défaut) : version actuelle (V1).',
  },
];

const FeatureFlagsSettings = () => {
  const { flags, setFlag } = useFeatureFlags();
  return (
    <Box sx={{ maxWidth: 620, margin: '8px auto 40px', padding: '0 16px' }}>
      <TitlePart id="featureFlags" span="Fonctionnalités (bêta)" />
      <Box
        sx={{
          textAlign: 'center',
          color: dsV2.color.t3,
          fontSize: 13,
          lineHeight: 1.5,
          margin: '4px auto 20px',
          maxWidth: 460,
        }}
      >
        Options en cours de déploiement, activables pour tester. Réglages propres à ce navigateur.
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {FEATURES.map((feature) => (
          <Box
            key={feature.key}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: '16px',
              padding: '14px 18px',
              border: `1px solid ${dsV2.color.border}`,
              borderRadius: dsV2.radius.md,
              background: dsV2.color.surface,
              boxShadow: dsV2.shadow.sm,
            }}
          >
            <Box sx={{ minWidth: 0 }}>
              <Box sx={{ fontSize: 14, fontWeight: 600, color: dsV2.color.noir }}>{feature.title}</Box>
              <Box sx={{ fontSize: 12.5, color: dsV2.color.t3, marginTop: '3px', lineHeight: 1.45 }}>
                {feature.description}
              </Box>
            </Box>
            <Switch
              size="small"
              id={`ff-${feature.key}`}
              checked={flags[feature.key]}
              onSwitch={(_e, checked) => setFlag(feature.key, checked)}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default FeatureFlagsSettings;
